import { AllActions } from "../actions";
import { Ui } from "../../interfaces";
import * as constants from "../constants";

export const initialUiState: Ui = {
  dataLoaded: true,
  requestInProgress: false,
  dataRequested: false,
};

export function ui(
  state: Ui = initialUiState,
  action: AllActions,
): Ui {
  if (state === undefined) {
    state = {
      dataLoaded: false,
      requestInProgress: false,
      dataRequested: false,
    };
  }

  switch (action.type) {
    case constants.DATA_REQUESTED:
      return { ...state, dataLoaded: false, dataRequested: true };
    case constants.DATA_LOADED:
      return { ...state, dataLoaded: true, requestInProgress: false, dataRequested: false };
    case constants.REQUEST_IN_PROGRESS:
      return { ...state, dataLoaded: false, requestInProgress: true };
  }
  return state;
}
